"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _NavigateBefore = _interopRequireDefault(require("@material-ui/icons/NavigateBefore"));

var _NavigateNext = _interopRequireDefault(require("@material-ui/icons/NavigateNext"));

var _SwapVert = _interopRequireDefault(require("@material-ui/icons/SwapVert"));

var _Paper = _interopRequireDefault(require("../Paper/Paper"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _TableLoadingBackground = _interopRequireDefault(require("./TableLoadingBackground"));

var _TableModule = _interopRequireDefault(require("./Table.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * # Table
 * Foodbomb Table Component with sorting, pagination and row actions
 *
 * ## PropTypes:
 * ```js
 *Table.propTypes = {
 *  columnSpecs: PropTypes.arrayOf(
 *    PropTypes.exact({
 *      index: PropTypes.number.isRequired,
 *      title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node, PropTypes.func]),
 *      mobileText: PropTypes.string,
 *      sortMethod: PropTypes.string,
 *      className: PropTypes.string,
 *      columnDataFunction: PropTypes.func.isRequired,
 *      searchable: PropTypes.bool,
 *      rightAlign: PropTypes.bool,
 *      getChild: PropTypes.func,
 *    }),
 *  ),
 *  rowActions: PropTypes.func,
 *  rowOverlayColSpan: (props, propName, componentName) => {
 *    if (props.rowActions && typeof props.rowActions === 'function' && props[propName] === undefined) {
 *      return new Error(`Missing prop '${propName}' must be supplied to ${componentName} if 'rowActions' is defined. `);
 *    }
 *    return 0;
 *  },
 *  handleRowClick: PropTypes.func,
 *  noResultsComponent: PropTypes.object.isRequired,
 *  className: PropTypes.string,
 *  numberOfRowsPerPage: PropTypes.number,
 *  searchQuery: PropTypes.string,
 *  isFiltering: PropTypes.bool,
 *  loadingRowData: PropTypes.bool,
 *  rowData: PropTypes.array.isRequired,
 *  stickyFirstColumn: PropTypes.bool,
 *  loadingComponent: PropTypes.node,
 *  grow: PropTypes.bool,
 *  noPadding: PropTypes.bool,
 *  hideMobileArrow: PropTypes.bool,
 *  hideNavigationData: PropTypes.bool,
 *  defaultSortColumn: PropTypes.number,
 *  sortAscending: PropTypes.bool,
 *  sortOverrideMethod: PropTypes.func,
 *  paginationOverrideData: PropTypes.exact({
 *    currentPageNumber: PropTypes.number.isRequired,
 *    onNextPageClick: PropTypes.func,
 *    onPreviousPageClick: PropTypes.func,
 *    pageSize: PropTypes.number.isRequired,
 *    numberOfResults: PropTypes.number.isRequired
 *    resetToPageOne: PropTypes.func,
 *  }),
 *  tableContentContainerStyle: PropTypes.string,
 *  useServerSidePagination: PropTypes.bool,
 *};
 * ```
 *
 * ## Table API
 *
 *| PROPERTY                | REQUIRED           | TYPE             | DESCRIPTION                                                                                                                                |
 *|-------------------------|--------------------|------------------|--------------------------------------------------------------------------------------------------------------------------------------------|
 *| className               | false              | string           | The CSS class to apply to the table                                                                                                        |
 *| columnSpecs             | true               | array of objects | Column specs which define the data and behaviour of each column. See example.                                                              |
 *| handleRowClick          | false              | function         | The function to be called when a row in the table is clicked.  NOTE: you may wish to trigger this on screens < 768px if you haveRowActions |
 *| rowOverlayColSpan       | true if rowActions | integer          | The number of columns to be taken up by the supplier row actions when hovering. Required if actions are supplied.                          |
 *| rowActions              | false              | function         | A function that returns a React.Fragment containing the buttons/text to be displayed on the row                                            |
 *| noResultsComponent      | true               | node             | The component to be displayed instead of the table, if the table has no results                                                            |
 *| numberOfRowsPerPage     | false              | number           | The number of rows to show per paginated page                                                                                              |
 *| searchQuery             | false              | string           | The current search query submitted to the parent component search bar (if present)                                                         |
 *| isFiltering             | false              | bool             | Is the current data set being filterd, hence should the no results replace the 0 results comp                                              |
 *| loadingRowData          | false              | bool             | Boolean value representing if the rowData variable is still loading from an async function                                                 |
 *| rowData                 | true               | array            | Array of rows of data to display matching the column specs                                                                                 |
 *| paginationOverrideData  |  false             | object           | Object with override information for pagination                                                                                            |
 *| stickyFirstColumn       | false              | bool             | Should the first column be sticky to the left on mobile devices                                                                            |
 *| loadingComponent        | false              | object           | Optional loading component to override the default                                                                                         |
 *| grow                    | false              | bool             | Should the component expand to take up its container                                                                                       |
 *| noPadding               | false              | bool             | Should the component remove all padding from its container                                                                                 |
 *| hideMobileArrow         | false              | bool             | Should hide the mobile green arrow                                                                                                         |
 *| hideNavigationData      | false              | bool             | Should hide the "showing x / y" results and navigational elements                                                                          |
 *| defaultSortColumn       | false              | number           | Allows for the selection of the default sort column by providing the column ID. First column used if none provided.                        |
 *| sortAscending           | false              | bool             | Allows for the selection of the default sort direction for the default sort column                                                         |
 *| sortOverrideMethod      | false              | func             | Callback function to override sorting and enable sorting to happen outside the table. Returns valueToSortBy and shouldSortByMin            |
 *| useServerSidePagination | false              | bool             | Flag to specify if the implementor is using serverSidePagination (used in combination with paginationOverrideData to handle pagination)    |
 *
 * ## Column Spec Definition
 * ```
 * const columnSpecs = [
 *   {
 *      index: 0,                                                --> Columns are zero indexed
 *      title: 'Price',
 *      mobileText: 'mobile column title',
 *      sortMethod: 'totals.grandTotal',                      --> This is a string to reference which column is currently being sorted
 *      className: styles.Price,
 *      columnDataFunction: order => order.totals.grandTotal, --> How to get the data to be displayed
 *      getChild: createPriceDisplay,                         --> Optional: Provide this if you want to display another widget instead of displaying the result of the column data function
 *      rightAlign: true,                                     --> if the column data must be right aligned
 *
 *   },
 * ]
 *
 *
 */
var Table = function Table(_ref) {
  var columnSpecs = _ref.columnSpecs,
      rowActions = _ref.rowActions,
      handleRowClick = _ref.handleRowClick,
      noResultsComponent = _ref.noResultsComponent,
      className = _ref.className,
      rowOverlayColSpan = _ref.rowOverlayColSpan,
      numberOfRowsPerPage = _ref.numberOfRowsPerPage,
      searchQuery = _ref.searchQuery,
      isFiltering = _ref.isFiltering,
      loadingRowData = _ref.loadingRowData,
      rowData = _ref.rowData,
      paginationOverrideData = _ref.paginationOverrideData,
      stickyFirstColumn = _ref.stickyFirstColumn,
      loadingComponent = _ref.loadingComponent,
      grow = _ref.grow,
      noPadding = _ref.noPadding,
      hideMobileArrow = _ref.hideMobileArrow,
      hideNavigationData = _ref.hideNavigationData,
      defaultSortColumn = _ref.defaultSortColumn,
      sortAscending = _ref.sortAscending,
      sortOverrideMethod = _ref.sortOverrideMethod,
      tableContentContainerStyle = _ref.tableContentContainerStyle,
      useServerSidePagination = _ref.useServerSidePagination;
  var HAS_PAGINATION_OVERRIDE_DATA = paginationOverrideData && Object.keys(paginationOverrideData).length;
  var NUMBER_OF_ROWS_PER_PAGE = HAS_PAGINATION_OVERRIDE_DATA ? paginationOverrideData.pageSize : numberOfRowsPerPage || 15;

  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      sortedRowData = _useState2[0],
      setSortedRowData = _useState2[1];

  var _useState3 = (0, _react.useState)(1),
      _useState4 = _slicedToArray(_useState3, 2),
      currentPage = _useState4[0],
      setCurrentPage = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = _slicedToArray(_useState5, 2),
      flipMobileArrow = _useState6[0],
      setFlipMobileArrow = _useState6[1];

  var _useState7 = (0, _react.useState)(sortAscending === undefined ? true : sortAscending),
      _useState8 = _slicedToArray(_useState7, 2),
      sortByMin = _useState8[0],
      setSortByMin = _useState8[1];

  var _useState9 = (0, _react.useState)(columnSpecs[defaultSortColumn || 0].sortMethod),
      _useState10 = _slicedToArray(_useState9, 2),
      tableSortMethod = _useState10[0],
      setTableSortMethod = _useState10[1];

  var currentlyVisiblePage = HAS_PAGINATION_OVERRIDE_DATA ? paginationOverrideData.currentPageNumber : currentPage;
  var scrollableTableContainer = (0, _react.useRef)();
  var currentPageMinLimit = (currentlyVisiblePage - 1) * NUMBER_OF_ROWS_PER_PAGE + 1;
  var currentPageMaxLimit = currentlyVisiblePage * NUMBER_OF_ROWS_PER_PAGE;
  var currentPageToDisplay = useServerSidePagination ? currentPage : currentlyVisiblePage;
  var dataLength = HAS_PAGINATION_OVERRIDE_DATA ? paginationOverrideData.numberOfResults : sortedRowData.length;
  var paginatedElements = sortedRowData.slice((currentPageToDisplay - 1) * NUMBER_OF_ROWS_PER_PAGE, currentPageToDisplay * NUMBER_OF_ROWS_PER_PAGE);

  var scrollTableToEnd = function scrollTableToEnd() {
    scrollableTableContainer.current.scroll({
      left: 1500,
      behavior: 'smooth'
    });
  };

  var scrollTableToStart = function scrollTableToStart() {
    scrollableTableContainer.current.scroll({
      left: 0,
      behavior: 'smooth'
    });
  };

  var handleFlipMobileArrow = function handleFlipMobileArrow() {
    if (flipMobileArrow) {
      scrollTableToEnd();
    } else {
      scrollTableToStart();
    }
  };

  var handleScrollTableContainer = function handleScrollTableContainer() {
    var currentScrollPosition = scrollableTableContainer.current.scrollLeft;
    var elemWidth = scrollableTableContainer.current.scrollWidth;
    var viewPortWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    var offset = 0;
    var percentageScrolled = (currentScrollPosition + viewPortWidth - offset) / elemWidth;
    setFlipMobileArrow(percentageScrolled <= 0.9);
  };

  var incrementCurrentPage = function incrementCurrentPage() {
    if (HAS_PAGINATION_OVERRIDE_DATA) {
      paginationOverrideData.onNextPageClick();
    } else {
      setCurrentPage(currentPage + 1);
    }
  };

  var decrementCurrentPage = function decrementCurrentPage() {
    if (HAS_PAGINATION_OVERRIDE_DATA) {
      paginationOverrideData.onPreviousPageClick();
    } else if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  var resetCurrentPage = function resetCurrentPage() {
    setCurrentPage(1);
  };

  var sortElements = function sortElements(elementsToSort, sortField, shouldSortByMin) {
    return elementsToSort.sort(function (a, b) {
      var value1 = sortField.split('.').reduce(function (o, k) {
        return o && o[k];
      }, !shouldSortByMin ? b : a);
      var value2 = sortField.split('.').reduce(function (o, k) {
        return o && o[k];
      }, !shouldSortByMin ? a : b);

      if (value1 === undefined || value1 === null) {
        return 0;
      }

      if (value2 === undefined || value2 === null) {
        return 1;
      }

      if (typeof value1 === 'number' || value1 instanceof Date) {
        return value1 - value2;
      }

      if (typeof value1 === 'string') {
        return value1.localeCompare(value2);
      }

      if (typeof value1 === 'boolean') {
        if (value1 === value2) {
          return 0;
        }

        return value1 ? -1 : 1;
      }

      return -1;
    });
  };

  var setSortMethod = function setSortMethod(valueToSortBy) {
    var shouldSortByMin = valueToSortBy === tableSortMethod ? !sortByMin : false;

    if (sortOverrideMethod) {
      sortOverrideMethod(valueToSortBy, shouldSortByMin);
    } else {
      var sortedElements = sortElements(rowData, valueToSortBy, shouldSortByMin);
      setSortedRowData(sortedElements);
    }

    setTableSortMethod(valueToSortBy);
    setSortByMin(shouldSortByMin);
    resetCurrentPage();

    if (HAS_PAGINATION_OVERRIDE_DATA && (paginationOverrideData === null || paginationOverrideData === void 0 ? void 0 : paginationOverrideData.resetToPageOne)) {
      paginationOverrideData.resetToPageOne();
    }
  };

  (0, _react.useEffect)(function () {
    var sortedElements = tableSortMethod ? sortElements(rowData, tableSortMethod, sortByMin) : rowData;
    setSortedRowData(sortedElements); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowData, loadingRowData]);
  (0, _react.useEffect)(function () {
    if (!HAS_PAGINATION_OVERRIDE_DATA) {
      resetCurrentPage();
    }
  }, [searchQuery, rowData, HAS_PAGINATION_OVERRIDE_DATA]);

  var getTableHeaderClasses = function getTableHeaderClasses(currentSortMethod, columnSortMethod) {
    if (columnSortMethod) {
      if (currentSortMethod === columnSortMethod) {
        return [_TableModule.default.TableHeaderContainer, _TableModule.default.Clickable, _TableModule.default.active].join(' ');
      }

      return [_TableModule.default.TableHeaderContainer, _TableModule.default.Clickable].join(' ');
    }

    return _TableModule.default.TableHeaderContainer;
  };

  var createTableCell = function createTableCell(columnSpec, rowElement, hideOnHover) {
    var cellClass = hideOnHover ? [_TableModule.default.TableCell__defaultShow, columnSpec.className].join(' ') : columnSpec.className;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: "cell_".concat(columnSpec.index, "_").concat(Object.values(rowElement)[0], "_").concat(columnSpec.columnDataFunction(rowElement), "_").concat(hideOnHover)
    }, columnSpec.index === 0 ? /*#__PURE__*/_react.default.createElement("th", {
      className: cellClass
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: columnSpec.rightAlign ? [_TableModule.default.MobileWhiteBackgroundFaker, _TableModule.default.RightAlign].join(' ') : _TableModule.default.MobileWhiteBackgroundFaker
    }, columnSpec.getChild ? columnSpec.getChild(rowElement) : columnSpec.columnDataFunction(rowElement)), stickyFirstColumn ? /*#__PURE__*/_react.default.createElement("div", {
      className: _TableModule.default.MobileBoxShadowFaker
    }) : null) : /*#__PURE__*/_react.default.createElement("td", {
      className: columnSpec.rightAlign ? [_TableModule.default.RightAlign, cellClass].join(' ') : cellClass
    }, columnSpec.getChild ? columnSpec.getChild(rowElement) : columnSpec.columnDataFunction(rowElement)));
  };

  var tableContentStyles = [_TableModule.default.Table__content];

  if (grow) {
    tableContentStyles.push(_TableModule.default.grow);
  }

  if (noPadding) {
    tableContentStyles.push(_TableModule.default.noPadding);
  }

  var potentiallyHandleRowClick = function potentiallyHandleRowClick(e, elem) {
    var excludedTagNames = ['INPUT', 'BUTTON'];

    if (!excludedTagNames.includes(e.target.tagName) && handleRowClick) {
      handleRowClick(elem);
    }
  };

  var contentContainerStyles = [_TableModule.default.Table__contentContainer];

  if (tableContentContainerStyle) {
    contentContainerStyles.push(tableContentContainerStyle);
  }

  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: contentContainerStyles.join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: tableContentStyles.join(' ')
  }, loadingRowData ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loadingComponent || /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: _TableModule.default.LoadingTablePaperWrapper
  }, /*#__PURE__*/_react.default.createElement(_TableLoadingBackground.default, null))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isFiltering || searchQuery || rowData.length ? /*#__PURE__*/_react.default.createElement(_Paper.default, {
    className: _TableModule.default.TablePaperWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _TableModule.default.TableContainer,
    ref: scrollableTableContainer,
    onScroll: handleScrollTableContainer
  }, hideMobileArrow ? null : /*#__PURE__*/_react.default.createElement("button", {
    className: _TableModule.default.MobileArrowContainer,
    onClick: handleFlipMobileArrow
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: flipMobileArrow ? [_TableModule.default.ReversibleArrow, _TableModule.default.reverse].join(' ') : _TableModule.default.ReversibleArrow
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: _TableModule.default.TopBar
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: _TableModule.default.BottomBar
  }))), /*#__PURE__*/_react.default.createElement("table", {
    className: stickyFirstColumn ? [_TableModule.default.Table, className, _TableModule.default.stickyFirstColumn].join(' ') : [_TableModule.default.Table, className].join(' ')
  }, /*#__PURE__*/_react.default.createElement("thead", null, /*#__PURE__*/_react.default.createElement("tr", {
    className: _TableModule.default.Table__row
  }, columnSpecs.map(function (col, idx) {
    return /*#__PURE__*/_react.default.createElement("th", {
      key: "col_".concat(col.index, "_col.title"),
      className: [col.className].join(' ')
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: col.rightAlign ? [_TableModule.default.MobileWhiteBackgroundFaker, _TableModule.default.RightAlign].join(' ') : _TableModule.default.MobileWhiteBackgroundFaker
    }, /*#__PURE__*/_react.default.createElement("button", {
      className: getTableHeaderClasses(tableSortMethod, col.sortMethod),
      onClick: col.sortMethod ? function () {
        return setSortMethod(col.sortMethod);
      } : undefined
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: col.mobileText ? _TableModule.default.HideMobile : undefined
    }, col.title), col.mobileText ? /*#__PURE__*/_react.default.createElement("div", {
      className: _TableModule.default.HideDesktop
    }, col.mobileText) : null, col.sortMethod ? /*#__PURE__*/_react.default.createElement(_SwapVert.default, {
      className: tableSortMethod === col.sortMethod ? [_TableModule.default.SortByIcon, _TableModule.default.active].join(' ') : _TableModule.default.SortByIcon
    }) : null)), idx === 0 && stickyFirstColumn ? /*#__PURE__*/_react.default.createElement("div", {
      className: _TableModule.default.MobileBoxShadowFaker
    }) : null);
  }))), /*#__PURE__*/_react.default.createElement("tbody", null, paginatedElements.map(function (elem) {
    return /*#__PURE__*/_react.default.createElement("tr", {
      key: "elem_".concat(Object.values(elem).join('_')),
      className: [_TableModule.default.Table__row, _TableModule.default.bodyRow].join(' '),
      onClick: function onClick(e) {
        return potentiallyHandleRowClick(e, elem);
      }
    }, columnSpecs.map(function (spec) {
      // if there are no row actions - just render the columns
      if (!rowActions) {
        return createTableCell(spec, elem, false);
      }

      if (spec.index < columnSpecs.length - rowOverlayColSpan) {
        return createTableCell(spec, elem, false);
      }

      if (spec.index === columnSpecs.length - rowOverlayColSpan) {
        return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
          key: "overlayColumn_".concat(JSON.stringify(Object.values(elem).join('_')))
        }, /*#__PURE__*/_react.default.createElement("td", {
          colSpan: rowOverlayColSpan,
          className: [_TableModule.default.Grow, _TableModule.default.TableCell__showOnHover].join(' ')
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: _TableModule.default.TableFlexContainer
        }, rowActions(elem))), createTableCell(spec, elem, true));
      }

      return createTableCell(spec, elem, true);
    }));
  })))), !hideNavigationData ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _TableModule.default.ElementsCountContainer
  }, dataLength ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "Showing rows ", currentPageMinLimit, " -", ' ', currentPageMaxLimit < dataLength ? currentPageMaxLimit : dataLength, " of\xA0", dataLength, searchQuery ? " for search \"".concat(searchQuery, "\"") : null, isFiltering ? " in current filter" : null) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "No rows to display", searchQuery ? " for search \"".concat(searchQuery, "\"") : null, isFiltering ? " in current filter" : null)), dataLength > NUMBER_OF_ROWS_PER_PAGE ? /*#__PURE__*/_react.default.createElement("div", {
    className: _TableModule.default.PaginationButtonsContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: [_TableModule.default.PaginationBtn, _TableModule.default.PaginationBtn__prev].join(' '),
    variant: "secondary",
    size: "extra_small",
    disabled: currentlyVisiblePage === 1,
    onClick: decrementCurrentPage
  }, /*#__PURE__*/_react.default.createElement(_NavigateBefore.default, null)), "Page ", currentlyVisiblePage, " of ", Math.max(Math.ceil(dataLength / NUMBER_OF_ROWS_PER_PAGE), 1), /*#__PURE__*/_react.default.createElement(_Button.default, {
    className: [_TableModule.default.PaginationBtn, _TableModule.default.PaginationBtn__next].join(' '),
    variant: "secondary",
    size: "extra_small",
    onClick: incrementCurrentPage,
    disabled: currentlyVisiblePage >= Math.ceil(dataLength / NUMBER_OF_ROWS_PER_PAGE)
  }, /*#__PURE__*/_react.default.createElement(_NavigateNext.default, null))) : null) : null) : /*#__PURE__*/_react.default.createElement("div", null, noResultsComponent)))));
};

Table.propTypes = {
  columnSpecs: _propTypes.default.arrayOf(_propTypes.default.exact({
    index: _propTypes.default.number.isRequired,
    title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node, _propTypes.default.func]),
    mobileText: _propTypes.default.string,
    sortMethod: _propTypes.default.string,
    className: _propTypes.default.string,
    columnDataFunction: _propTypes.default.func.isRequired,
    searchable: _propTypes.default.bool,
    rightAlign: _propTypes.default.bool,
    getChild: _propTypes.default.func
  })),
  rowActions: _propTypes.default.func,
  rowOverlayColSpan: function rowOverlayColSpan(props, propName, componentName) {
    if (props.rowActions && typeof props.rowActions === 'function' && props[propName] === undefined) {
      return new Error("Missing prop '".concat(propName, "' must be supplied to ").concat(componentName, " if 'rowActions' is defined. "));
    }

    return 0;
  },
  paginationOverrideData: _propTypes.default.exact({
    currentPageNumber: _propTypes.default.number.isRequired,
    onNextPageClick: _propTypes.default.func,
    onPreviousPageClick: _propTypes.default.func,
    pageSize: _propTypes.default.number.isRequired,
    numberOfResults: _propTypes.default.number.isRequired,
    resetToPageOne: _propTypes.default.func
  }),
  handleRowClick: _propTypes.default.func,
  noResultsComponent: _propTypes.default.object.isRequired,
  className: _propTypes.default.string,
  numberOfRowsPerPage: _propTypes.default.number,
  searchQuery: _propTypes.default.string,
  isFiltering: _propTypes.default.bool,
  loadingRowData: _propTypes.default.bool,
  rowData: _propTypes.default.array.isRequired,
  stickyFirstColumn: _propTypes.default.bool,
  loadingComponent: _propTypes.default.object,
  grow: _propTypes.default.bool,
  noPadding: _propTypes.default.bool,
  hideMobileArrow: _propTypes.default.bool,
  hideNavigationData: _propTypes.default.bool,
  defaultSortColumn: _propTypes.default.number,
  sortAscending: _propTypes.default.bool,
  sortOverrideMethod: _propTypes.default.func,
  tableContentContainerStyle: _propTypes.default.string,
  useServerSidePagination: _propTypes.default.bool
};
var _default = Table;
exports.default = _default;

//# sourceMappingURL=Table.js.map